module.exports = __webpack_public_path__ + "static/media/master-card.602e91fc.svg";